// extracted by mini-css-extract-plugin
module.exports = {"tags":"TagList-module--tags--3bExx","title":"TagList-module--title--1X-t8","tag":"TagList-module--tag--3JKQi"};